// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
//import VueBlu from 'vue-blu'
import 'nprogress/nprogress.css'
//import leMarkdownEditor from 'le-markdown-editor'
import store from "./store";
import VueCookies from 'vue-cookies'

//引入全局css文件
import './assets/css/gloable.css'
import './assets/layui/css/layui.css'
import './assets/font-awesome/css/font-awesome.min.css'


 // will mount `Vue.prototype.$message`


Vue.config.productionTip = false

Vue.use(VueCookies)
/* eslint-disable no-new */

// 关闭浏览器刷新/后退时自动恢复滚动位置
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual'
}

// 兜底：pageshow 事件（bfcache 恢复场景）强制滚顶
window.addEventListener('pageshow', () => {
  window.scrollTo(0, 0)
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js